module.exports = __webpack_public_path__ + "static/media/SJ.8724e965.png";